import { createContext, useEffect, useReducer } from "react";
import { actions } from "../utils/constants";

const initialState = {
  loading: false,
  error: false,
  data: undefined
};

const reducer = (state, action) => {
 switch (action.type) {
   case actions.LOADING:
     return {...state, loading: true};

   case actions.SUCCESS:
     return { ...state, loading: false, error: false, data: action.data };
     
   case actions.ERROR:
     return { ...state, loading: false, error: true };
     
   default:
    return state;
 }
}

export const StoreContext = createContext();

export const StoreProvider = ({children}) => {
 const [state, dispatch] = useReducer(reducer, initialState);

useEffect(() => {
 dispatch({ type: actions.LOADING });
 fetch('/data.json')
 .then(response => response.json())
 .then(response => {
  dispatch({type: actions.SUCCESS, data: response})
 })
 .catch(err => {
  dispatch({ type: actions.ERROR });
 })
}, [])

 return <StoreContext.Provider value={{state, dispatch}}>
  {children}
 </StoreContext.Provider>
}